import { Card, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { GoogleMap, Marker, InfoWindow } from "@react-google-maps/api";
import { useJsApiLoader } from "@react-google-maps/api";

const gcpApiKey = process.env.REACT_APP_GCP_API_KEY;
const center = { lat: 23.0225, lng: 72.5714 };
const locations = [
  {
    srNo: 1,
    areaZone: "AEC",
    locations: "AEC flyover, Parash Nagar to Torrent Power - L",
    mediaVehicle: "Gantry",
    W: 30,
    H: 10,
    sqFt: 300,
    illu: "BL",
    ratePerMonth: "125,000",
    zone: "AEC",
    lat: 23.0537902,
    lng: 72.5468322,
  },
  {
    srNo: 2,
    areaZone: "AEC",
    locations: "AEC flyover, Parash Nagar to Torrent Power -R",
    mediaVehicle: "Gantry",
    W: 30,
    H: 10,
    sqFt: 300,
    illu: "BL",
    ratePerMonth: "125,000",
    zone: "AEC",
    lat: 23.0537902,
    lng: 72.5468322,
  },
  {
    srNo: 3,
    areaZone: "AEC",
    locations: "AEC flyover, Torrent Power to Parash Nagar - R",
    mediaVehicle: "Gantry",
    W: 30,
    H: 10,
    sqFt: 300,
    illu: "BL",
    ratePerMonth: "125,000",
    zone: "AEC",
    lat: 23.0534161,
    lng: 72.5472676,
  },
  {
    srNo: 4,
    areaZone: "AEC",
    locations: "AEC flyover, Torrent Power to Parash Nagar -L",
    mediaVehicle: "Gantry",
    W: 30,
    H: 10,
    sqFt: 300,
    illu: "BL",
    ratePerMonth: "125,000",
    zone: "AEC",
    lat: 23.0534161,
    lng: 72.5472676,
  },
  {
    srNo: 5,
    areaZone: "Airport Road",
    locations: "Airport Road, Facing City to Airport / Gandhinagar",
    mediaVehicle: "Unipole",
    W: 10,
    H: 20,
    sqFt: 200,
    illu: "BL",
    ratePerMonth: "165,000",
    zone: "Airport Road",
    lat: 23.0776793,
    lng: 72.6087584,
  },
  {
    srNo: 6,
    areaZone: "Airport Road",
    locations: "Airport Road, Airport to City",
    mediaVehicle: "Unipole",
    W: 14,
    H: 14,
    sqFt: 196,
    illu: "BL",
    ratePerMonth: "225,000",
    zone: "Airport Road",
    lat: 23.0787983,
    lng: 72.6102226,
  },
  {
    srNo: 7,
    areaZone: "Ambawadi",
    locations:
      "Ambawadi Opp. Raj Stationery FTF Excise Chowki to Neharunagar Circle",
    mediaVehicle: "Unipole",
    W: 14,
    H: 14,
    sqFt: 196,
    illu: "BL",
    ratePerMonth: "175,000",
    zone: "Ambawadi",
    lat: 23.0218834,
    lng: 72.5470517,
  },
  {
    srNo: 8,
    areaZone: "Ambawadi",
    locations: "Ambawadi CN School Circle To Panjarapole",
    mediaVehicle: "Gantry",
    W: 79,
    H: 13,
    sqFt: 1027,
    illu: "BL",
    ratePerMonth: "325,000",
    zone: "Ambawadi",
    lat: 23.0215127,
    lng: 72.5522245,
  },
  {
    srNo: 9,
    areaZone: "Ambawadi",
    locations: "Ambawadi CN School Circle To Ambawadi Circle",
    mediaVehicle: "Gantry",
    W: 79,
    H: 13,
    sqFt: 1027,
    illu: "BL",
    ratePerMonth: "325,000",
    zone: "Ambawadi",
    lat: 23.0216157,
    lng: 72.552049,
  },
  {
    srNo: 10,
    areaZone: "Ashram Road",
    locations:
      "Ashram Road Arjun Nivas Nr V S Hospital FTF Paldi Circle to Town Hall",
    mediaVehicle: "Hoarding",
    W: 30,
    H: 15,
    sqFt: 450,
    illu: "BL",
    ratePerMonth: "125,000",
    zone: "Ashram Road",
    lat: 23.019732,
    lng: 72.5697004,
  },
  // Add the remaining locations here
];

function BusComponent({filteredInventories}) {
  const [hoveredMarker, setHoveredMarker] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [clickedPosition, setClickedPosition] = useState(null);
  const [inventories, setInventories] = useState(
    useSelector((state) => state.inventoriesList.inventories)
  );
 
  useEffect(()=>{
    if(gcpApiKey){
      // console.log("🌐🌐🌎🌎🌍🌍",gcpApiKey)
    }
  },[])
  
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: gcpApiKey,
    libraries: ["places"],
  });

  const handleMarkerClick = (position) => {
    setClickedPosition(position);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const handleMarkerHover = (marker) => {
    setHoveredMarker(marker);
  };

  const resetHoveredMarker = () => {
    setHoveredMarker(null);
  };

  return (
    <Card
      style={{ width: "100%", borderRadius: 0 }}
      bodyStyle={{ padding: "0" }}
      headStyle={{ fontSize: "1.2rem" }}
      title={<h4 style={{ margin: 0,fontSize:"20px" }}>Map View of Inventory</h4>}
      bordered={false}
    >
      <div style={{ width: "100%", height: "500px" }}>
        {isLoaded ? (
          <GoogleMap
            center={center}
            zoom={12}
            mapContainerStyle={{ width: "100%", height: "100%" }}
          >
            {/* Render markers for each location */}
            {filteredInventories.map((ele, index) => (
              <Marker
                key={index}
                position={{ lat: ele.lat, lng: ele.lng }}
                icon={{
                  url: "https://prepseed.s3.ap-south-1.amazonaws.com/board.png",
                  scaledSize: new window.google.maps.Size(40, 40),
                }}
                onClick={() => handleMarkerClick(ele)}
                onMouseOver={() => handleMarkerHover(ele)}
              />
            ))}
            {hoveredMarker && (
              <InfoWindow
                position={{ lat: hoveredMarker.lat, lng: hoveredMarker.lng }}
                onCloseClick={() => {
                  resetHoveredMarker();
                }}
                options={{ maxWidth: 400 }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  {/* Image on the left */}
                  <img
                    src={hoveredMarker.img}
                    style={{
                      width: "100px",
                      height: "80px",
                      marginRight: "10px",
                      flexShrink: 0, // Prevent image from shrinking
                    }}
                    alt="Marker Image"
                  />
                  {/* Content on the right */}
                  <div>
                    <h6>
                      <b>Code No. : {hoveredMarker?.CodeNo}</b>
                    </h6>
                    <p>
                      <b>Zone: {hoveredMarker?.locations?.Area}</b>
                    </p>
                    <p style={{ maxWidth: "150px", wordWrap: "break-word" }}>
                      {hoveredMarker?.locations?.name}
                    </p>
                  </div>
                </div>
              </InfoWindow>
            )}
          </GoogleMap>
        ) : (
          <div>Loading...</div>
        )}
      </div>
      <Modal
        title="Marker Details"
        visible={isModalVisible}
        onCancel={handleModalClose}
        footer={null}
      >
        Latitude: {clickedPosition?.lat}
        <br />
        Longitude: {clickedPosition?.lng}
        {/* You can add more details or components here */}
      </Modal>
    </Card>
  );
}

export default BusComponent;
